import React, { useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import { TableCell, TableContainer, Table, Box } from "@material-ui/core";
import { TableHead, TableBody, TableRow, Popover } from "@material-ui/core";
// component
import Loader from "components/loader/Loader";
import FilterIcon from "assets/icons/icon.png";
// direct import
import "./index.scss";
import { PopoverActionCol, PopoverBox } from "./Theme";
import { PopoverButton, PopoverWrapper } from "./Theme";
import { fontConfig } from "theme/fontConfig";

const TableCellHead = withStyles(() => ({
  root: {
    height: "39px",
    padding: "0px 20px",
    borderBottom: "none",
    fontFamily: fontConfig.GeneralTableCellHeadFont.family,
  },
}))(TableCell);

const TableCellBody = withStyles(() => ({
  root: {
    height: "65px",
    padding: "0px 20px",
    fontFamily: fontConfig.GeneralTableCellBodyFont.family,
    fontSize: "12px",
    color: "#4F4F4F",
  },
}))(TableCell);

const TableColumnFilter = ({
  options = [],
  onChange,
  value = [],
  isNotAllNeed = false,
  filterKey,
  optionComponent = null,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleFilterChange = (val) => {
    onChange(filterKey, val, options);
  };

  const isAllSelected =
    !isNotAllNeed &&
    options.length > 0 &&
    value.length === options.length &&
    options.every((opt) => value.includes(opt.value));

  return (
    <div>
      <PopoverButton onClick={handleClick} style={{ position: "relative" }}>
        <img src={FilterIcon} alt="filter" />
        {!isAllSelected && value?.length > 0 && (
          <Box
            sx={{
              width: 6,
              height: 6,
              backgroundColor: "#ff3668",
              borderRadius: "50%",
              position: "absolute",
              top: -3,
              right: -4,
              zIndex: 100,
            }}
          ></Box>
        )}
      </PopoverButton>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        PaperProps={{
          style: {
            width: 330,
            maxWidth: "100%",
          },
        }}
      >
        <PopoverWrapper>
          {/* Render custom component if provided */}
          {optionComponent ? (
            <>{optionComponent()}</>
          ) : (
            <>
              {!isNotAllNeed && (
                <PopoverActionCol onClick={() => handleFilterChange("all")}>
                  <PopoverBox checked={isAllSelected} />
                  <span>All</span>
                </PopoverActionCol>
              )}

              {options?.map((opt) => (
                <PopoverActionCol
                  key={opt.value}
                  onClick={() => handleFilterChange(opt.value)}
                >
                  <PopoverBox checked={value.includes(opt.value)} />
                  <span>{opt.label}</span>
                </PopoverActionCol>
              ))}
            </>
          )}
        </PopoverWrapper>
      </Popover>
    </div>
  );
};

const EventTable = ({
  tasksList = [],
  columns,
  loading,
  selectedFilter,
  onEventTypeFilterChange,
  onRowClick,
}) => {
  return (
    <div className="schedule-table-container">
      <TableContainer className="scroll-table">
        <Table className="main-tables" aria-label="task automation table">
          <TableHead className="charges-table sticky-table-header">
            <TableRow>
              {columns?.map((col) => (
                <TableCellHead key={col?.field}>
                  <div
                    className="d-flex h-100 justify-content-start align-items-center"
                    style={{ gap: "10px" }}
                  >
                    {col?.headerName}
                    {col?.hasFilter && (
                      <TableColumnFilter
                        options={col?.options ?? []}
                        onChange={(filterKey, val, options) =>
                          onEventTypeFilterChange(filterKey, val, options)
                        }
                        value={selectedFilter?.[col.filterKey]}
                        isNotAllNeed={col?.isNotAllNeed}
                        filterKey={col?.filterKey}
                        optionComponent={col?.optionComponent}
                      />
                    )}
                  </div>
                </TableCellHead>
              ))}
              <TableCellHead className="empty-heads sticky-header-column" />
            </TableRow>
          </TableHead>

          <TableBody className="tran-table-body-schedules">
            {loading ? (
              <TableRow>
                <TableCell colSpan={columns.length + 1} align="center">
                  <div className="user__loader" style={{ height: "320px" }}>
                    <Loader />
                  </div>
                </TableCell>
              </TableRow>
            ) : tasksList?.length === 0 ? (
              <TableRow>
                <TableCell colSpan={columns.length + 1} align="center">
                  <h6 style={{ height: "320px", marginTop: "100px" }}>
                    No Data Found
                  </h6>
                </TableCell>
              </TableRow>
            ) : (
              tasksList?.map((row) => (
                <TableRow key={row.id}>
                  {columns?.map((col) => (
                    <TableCellBody
                      key={col?.field}
                      onClick={() => onRowClick(row)}
                      style={{ cursor: "pointer" }}
                    >
                      {col?.renderCell(row)}
                    </TableCellBody>
                  ))}
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default EventTable;
